import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { t } from '../../../../../../infra/i18n';
import { PromoCodeComponent } from './promo-code';
import { useEditableField } from '../../../hooks/use-editable-field';
import { usePromoCodes } from './hooks/use-promo-codes';
export var PromoCodeContainer = function () {
    var _a = useEditableField('promoId'), promoIdField = _a.field, setPromoIdField = _a.setValue;
    var _b = usePromoCodes(), promoCodes = _b.promoCodes, isPromoCodesLoading = _b.isPromoCodesLoading, isViewerCampaignOwner = _b.isViewerCampaignOwner;
    var _c = useState(false), addNewPromoCodeModalOpen = _c[0], setAddNewPromoCodeModalOpen = _c[1];
    var subtitle = isViewerCampaignOwner
        ? t('engage:campaign_builder.promo_code.subtitle_owner')
        : t('engage:campaign_builder.promo_code.subtitle_non_owner');
    return (_jsx(PromoCodeComponent, { subtitle: subtitle, selectedPromoCodeId: promoIdField.value, onSelectPromoCodeId: setPromoIdField, addNewPromoCodeModalOpen: addNewPromoCodeModalOpen, onAddNewPromoCodeModalOpenChange: setAddNewPromoCodeModalOpen, promoCodes: promoCodes, isPromoCodesLoading: isPromoCodesLoading, promoIdFieldErrors: promoIdField.error, isViewerCampaignOwner: isViewerCampaignOwner }));
};
